import { useTranslation } from "react-i18next";
import { AppButton } from "@/shared/Components";
import { privacyPolicy, termsConditions } from "@/shared/constants/umarta-links";
import { SupportLinks } from "@/common/SupportLinks";
import type { FC } from "react";
import styles from "./styles.module.scss";

interface Props {
  onClick?: () => void;
}

export const FooterLinks: FC<Props> = ({ onClick }) => {
  const { t } = useTranslation();

  const appVersion = window.__RUNTIME_CONFIG__.APP_VERSION;

  return (
    <div className={styles.root}>
      <SupportLinks />
      <div className={styles.separator} />
      <AppButton
        href={termsConditions}
        target="_blank"
        onClick={onClick}
        type={"text"}
        className={styles.button}
      >
        {t("logInPage.termsAndConditions")}
      </AppButton>
      <AppButton
        href={privacyPolicy}
        target="_blank"
        onClick={onClick}
        type={"text"}
        className={styles.button}
      >
        {t("logInPage.privacyPolicy")}
      </AppButton>
      <div className={styles["content-row"]}>
        {t("logInPage.version")}: {appVersion}
      </div>
    </div>
  );
};
